import ErrorPage from '@jg/error-page';
import React from 'react';

const ErrorPageWrapper = () => (
  <div className="container jg-space-phms@md">
    <div className="jg-space-pvml">
      <ErrorPage errorMessage="Page failed to render." status={500} />
    </div>
  </div>
);

export default ErrorPageWrapper;
